import { getDoorType } from "./index36.js";
import { sort2dObjsbyVector } from "./index37.js";
import { DOOR_TYPE, GetAllMuscles, RG_TYPE, SpaceAccess, deepFlatChildren, roundDecimals } from "@project-rouge/rg-core";
import { V3toVector3, Vector3toV3, addOpeningOnClosestPoint, applyInverseTransform, applyTransform, distanceToLine, getPivot, getPivotRaw } from "@project-rouge/rg-three";
import { Vector3 } from "three";
function addDoorsToTechnicalSpaces({ building, dataset }) {
	const rvData = dataset.rvData;
	const singleDoorId = dataset.modulousIds.techSpaceSingleDoorId;
	const doubleDoorId = dataset.modulousIds.techSpaceDoubleDoorId;
	const allMuscles = GetAllMuscles(building.data.anatomy);
	const techSpaces = building.children.filter((c) => c.type === RG_TYPE.TechnicalSpace);
	for (const techSpace of techSpaces) {
		const modulousId = getDoorType(techSpace) === DOOR_TYPE.Double ? doubleDoorId : singleDoorId;
		const tendon = allMuscles.filter((m) => m.id === techSpace.data.muscleID)[0].bone.tendon;
		const corridor = building.children.find((c) => c.type === RG_TYPE.Corridor && c.data.tendonID === tendon.id && c.data.level === techSpace.data.level);
		const centerline = [getPivotRaw([
			0,
			0,
			.5
		], corridor), getPivotRaw([
			1,
			0,
			.5
		], corridor)];
		let targetModule;
		const techSpaceModules = techSpace.children.filter((c) => c.type === RG_TYPE.Module);
		if (techSpaceModules.length === 1) targetModule = techSpaceModules[0];
		else {
			const sortedModules = sort2dObjsbyVector(techSpaceModules, [centerline[1][0] - centerline[0][0], centerline[1][2] - centerline[0][2]], (p) => Vector3toV3(applyTransform(p, techSpace)));
			targetModule = sortedModules[Math.floor(sortedModules.length * .5)];
		}
		const floors = deepFlatChildren(targetModule).filter((c) => c.type === RG_TYPE.Floor);
		const heightPivot = (Math.max(...floors.map((f) => f.pos[1] + f.size[1])) + targetModule.anchor[1] * targetModule.size[1]) / targetModule.size[1];
		let refPoint;
		if (techSpace.data.instance.attributes.access === SpaceAccess.Street) refPoint = getPivot([
			.5,
			heightPivot,
			1
		], targetModule);
		else {
			const pivot = getPivot([
				.5,
				heightPivot,
				0
			], targetModule);
			const pivotOnBuilding = V3toVector3(applyTransform(pivot, techSpace));
			const { closest } = distanceToLine(pivotOnBuilding, centerline);
			const v1 = closest.sub(pivotOnBuilding);
			const v2 = new Vector3().fromArray(centerline[1]).sub(new Vector3().fromArray(centerline[0])).setY(0);
			if (Math.abs(roundDecimals(v1.dot(v2))) !== 0) {
				const corridorRef = centerline[pivotOnBuilding.distanceToSquared(new Vector3().fromArray(centerline[0])) < pivotOnBuilding.distanceToSquared(new Vector3().fromArray(centerline[1])) ? 0 : 1];
				const corridorRefOnModule = applyInverseTransform([
					corridorRef[0],
					corridorRef[1],
					corridorRef[2]
				], techSpace);
				refPoint = new Vector3(corridorRefOnModule[0], pivot.y, corridorRefOnModule[2]);
			} else refPoint = pivot.clone();
			addOpeningOnClosestPoint({
				obj: targetModule,
				modulousId,
				rvDataList: rvData,
				type: RG_TYPE.Door,
				point: applyInverseTransform(refPoint, targetModule),
				isEntrance: true
			});
		}
	}
}
export { addDoorsToTechnicalSpaces };

//# sourceMappingURL=index38.js.map